import { render, staticRenderFns } from "./CalendarDialogEditEvent.vue?vue&type=template&id=1213e0ac&scoped=true"
import script from "./CalendarDialogEditEvent.vue?vue&type=script&lang=js"
export * from "./CalendarDialogEditEvent.vue?vue&type=script&lang=js"
import style0 from "./CalendarDialogEditEvent.vue?vue&type=style&index=0&id=1213e0ac&prod&scoped=true&lang=css"
import style1 from "./CalendarDialogEditEvent.vue?vue&type=style&index=1&id=1213e0ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213e0ac",
  null
  
)

export default component.exports